import { render } from "./CajA.vue?vue&type=template&id=172d625a&scoped=true"
import script from "./CajA.vue?vue&type=script&lang=js"
export * from "./CajA.vue?vue&type=script&lang=js"

import "./CajA.vue?vue&type=style&index=0&id=172d625a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172d625a"]])

export default __exports__